import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../../store';

export interface SearchProps {
  value: string;
}

// Define the initial state using that type
const initialState: SearchProps = {
  value: '',
};

export const searchSlice = createSlice({
  name: 'search',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setSearchTextValue: (state, action: PayloadAction<string>) => {
      state.value = action.payload;
    },
  },
});

export const { setSearchTextValue } = searchSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectValue = (state: RootState) => state.search.value;

export default searchSlice.reducer;
